import React from 'react';
import { Route, Routes } from 'react-router-dom';
import PrivateRoute from '../../common/components/router/PrivateRoute';
import Cart from '../../features/cart/Cart';
import CartDetails from '../../features/cart/CartDetails';
import NotFound from '../../common/components/router/NotFound';

const CartAppRoutes = () => (
  <Routes>
    <Route
      path="/search"
      element={
        <PrivateRoute>
          <Cart />
        </PrivateRoute>
      }
    />
    <Route
      path="/details/:cartId"
      element={
        <PrivateRoute>
          <CartDetails />
        </PrivateRoute>
      }
    />
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default CartAppRoutes;
